


























































import { Component, Vue } from "vue-property-decorator";
import userApi from "@/api/userApi";
import ForgotPasswordCompleted from "@/views/pages/forgotPasswordCompleted.vue";
import QErrors from "@/common/qErrors.vue";
@Component({
  name: "ForgotPassword",
  components: {
    ForgotPasswordCompleted,
    QErrors,
  },
})
export default class ForgotPassword extends Vue {
  public isShow = false;
  public form = {
    login_id: "",
    email: "",
  };

  public errors = {};
  public errorMessage = "";
  public show() {
    this.form = {
      login_id: "",
      email: "",
    };
    this.errors = {};
    this.isShow = true;
  }

  async send() {
    try {
      const response = await userApi.forgotPassword(this.form);

      if (response.meta.status == 200) {
        this.errors = {};
        (this.$refs.forgotPasswordCompleted as ForgotPasswordCompleted).show(
          response.data.send_to_email
        );
        this.isShow = false;
      } else {
        this.errors = response.meta.errors;
      }
    } catch (error) {
      if (error.response) {
        this.errorMessage = error.response.data.meta.message;
      } else {
        console.log(error);
      }
    }
  }
}
